import { Translation } from 'cng-common/features/translations/components/translation'

import { getActualsAndPlansYearsQuarters } from '../../../helpers/getActualsAndPlansYearsQuarters'
import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'

interface IProps {
  fYear: number
  fQuarter: number
}

export const HpSobNote = ({ fYear, fQuarter }: IProps) => {
  const { currentYearActuals, prevFYear, currentYearPlans } = getActualsAndPlansYearsQuarters({
    fYear,
    fQuarter,
  })

  const translation = currentYearActuals
    ? getFormedEltTranslation('hp-sob-note-with-actuals')
    : getFormedEltTranslation('hp-sob-note')

  return (
    <Translation
      text={translation}
      replaceParams={[
        { key: '{prevFYear}', value: String(prevFYear) },
        { key: '{currentYearActuals}', value: currentYearActuals || '' },
        { key: '{currentYearPlans}', value: currentYearPlans },
      ]}
    />
  )
}
